import React from "react";
import { connect } from "react-redux";
import DossierActions from "../redux/DossierRedux";

import Layout from "../components/Layout";
import Loading from "../components/UI/Loading/Loading";
import HeaderForm from "../components/HeaderForm/HeaderForm";
import Button from "../components/UI/Button/Button";
import Input from "../components/UI/Input/Input";
import FormError from "../components/UI/FormError/FormError";
import {
  updateObject,
  checkValidity,
  isFormReadOnly,
  getFormErrors,
} from "../shared/utility";
import { yearOptions, sirenOptions } from "../shared/staticOptions";
import {/*adresse,*/ exercice/*, votreBienForm2*/ } from "../shared/staticTexts";
//import {Link} from "react-router-dom";

class DossierExercicePage extends React.Component {
  constructor(props) {
    super(props);
    const dossier = props.dossier;

    let requiredSiren = true;
    if (dossier && dossier.entity.hasSiren === false) {
      requiredSiren = false;
    }

    this.state = {
      form: {
        email: {
          elementType: "input",
          elementConfig: {
            type: "email",
            name: "email",
            placeholder: exercice.form.email.placeholder,
          },
          value: dossier && dossier.email ? dossier.email : "",
          validation: {
            required: true,
            isEmail: true,
          },
          valid: false,
          touched: false,
        },
        annee: {
          elementType: "select",
          elementConfig: {
            name: "annee",
            options: yearOptions,
          },
          value: dossier && dossier.annee ? dossier.annee : "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
        },
        hasSiren: {
          elementType: "radio",
          elementConfig: {
            name: "hasSiren",
            options: sirenOptions,
          },
          value:
            dossier && dossier.entity.hasSiren === false ? "false" : "true",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
        },
        siren: {
          elementType: "input",
          elementConfig: {
            type: "text",
            name: "siren",
            placeholder: exercice.form.siren.placeholder,
          },
          value: dossier && dossier.entity.siren ? dossier.entity.siren : "",
          validation: {
            required: requiredSiren,
            isNumeric: true,
            minLength: 9,
            maxLength: 9,
          },
          valid: false,
          touched: false,
        },
      },
      formErrors: [],
      formIsValid: false,
      isUpdated: false,
      isSubmitted: false,
      dossier: dossier,
      isReadOnlyForm: isFormReadOnly(dossier),
    };
  }

  static getDerivedStateFromProps = (nextProps, prevState) => {
    if (
      prevState.isSubmitted &&
      nextProps.dossier !== null &&
      prevState.dossier !== null
    ) {
      if (nextProps.dossier !== prevState.dossier) {
        nextProps.history.replace("/dossier/adresse");
      }
    }
    return nextProps;
  };

  submitHandler = (event) => {
    event.preventDefault();

    if (
      this.props.dossier &&
      this.props.dossier.status &&
      this.props.dossier.status !== "EnSaisie"
    ) {
      this.props.history.replace("/dossier/adresse");
      return false;
    }

    let formElements = {};
    for (let formElementIdentifier in this.state.form) {
      const formElementValue = this.state.form[formElementIdentifier].value;
      const updatedFormElement = updateObject(
        this.state.form[formElementIdentifier],
        {
          value: formElementValue,
          valid: checkValidity(
            formElementValue,
            this.state.form[formElementIdentifier].validation
          ),
          touched: true,
        }
      );
      formElements[formElementIdentifier] = updatedFormElement;
    }

    let formIsValid = true;
    const formData = {};
    for (let formElementIdentifier in formElements) {
      formIsValid = formElements[formElementIdentifier].valid && formIsValid;
      formData[formElementIdentifier] =
        formElements[formElementIdentifier].value;
    }

    this.setState({
      form: formElements,
      formIsValid: formIsValid,
      formErrors: getFormErrors(formElements),
    });

    if (formIsValid) {
      if (this.state.isUpdated) {
        this.setState({ isSubmitted: true });
        if (this.props.dossier === null) {
          let dossier = {
            email: formData["email"],
            annee: formData["annee"],
            entity: {
              hasSiren: formData["hasSiren"],
            },
            status: "EnSaisie",
          };
          if (formData["hasSiren"] === "true" && formData["siren"] !== "") {
            dossier.entity.siren = formData["siren"];
          }
          this.props.saveDossier(dossier);
        } else {
          let {
            timestampCreation,
            timestampModification,
            ...dossier
          } = this.props.dossier;
          dossier.entity = { ...dossier.entity };
          dossier.email = formData["email"];
          dossier.annee = formData["annee"];
          dossier.entity.hasSiren = formData["hasSiren"];
          dossier.entity.siren = formData["siren"];
          dossier.status = "EnSaisie";
          this.props.saveDossier(dossier);
        }
      } else {
        this.props.history.replace("/dossier/adresse");
      }
    }
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedFormElement = updateObject(this.state.form[inputIdentifier], {
      value: event.target.value,
      valid: checkValidity(
        event.target.value,
        this.state.form[inputIdentifier].validation
      ),
      touched: true,
    });

    const updatedForm = updateObject(this.state.form, {
      [inputIdentifier]: updatedFormElement,
    });

    // setup dependencies
    if (inputIdentifier === "hasSiren") {
      if (updatedFormElement.value === "true") {
        updatedForm.siren.validation = {
          required: true,
          isNumeric: true,
          minLength: 9,
          maxLength: 9,
        };
        updatedForm.siren.valid = false;
        updatedForm.siren.touched = false;
      } else {
        updatedForm.siren.validation = {};
        updatedForm.siren.valid = true;
        updatedForm.siren.touched = true;
        updatedForm.siren.value = "";
      }
    }

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid,
      isUpdated: true,
    });
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }
    const isHavingSiren = this.state.form.hasSiren.value.toString();

    const formElementsArray = [];
    for (let key in this.state.form) {
      formElementsArray.push({
        id: key,
        config: this.state.form[key],
      });
    }

    let form = (
      <form
        className="dossier-form dossier-step1 py-5"
        onSubmit={this.submitHandler}
      >
        <div className="form-row mb-3">
          <div className="col-sm-6 text-right">
            <label
              htmlFor={formElementsArray[0].id}
              className="col-form-label required"
            >
              {exercice.form.email.label}
            </label>
          </div>
          <div className="col-sm-3">
            <Input
              key={formElementsArray[0].id}
              elementType={formElementsArray[0].config.elementType}
              elementConfig={formElementsArray[0].config.elementConfig}
              label={formElementsArray[0].config.label}
              value={formElementsArray[0].config.value}
              invalid={!formElementsArray[0].config.valid}
              shouldValidate={formElementsArray[0].config.validation}
              touched={formElementsArray[0].config.touched}
              isReadOnly={this.state.isReadOnlyForm}
              changed={(event) =>
                this.inputChangedHandler(event, formElementsArray[0].id)
              }
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-sm-6 text-right">
            <label
              htmlFor={formElementsArray[1].id}
              className="col-form-label required"
            >
              {exercice.form.annee.label}
            </label>
          </div>
          <div className="col-sm-3">
            <Input
              key={formElementsArray[1].id}
              elementType={formElementsArray[1].config.elementType}
              elementConfig={formElementsArray[1].config.elementConfig}
              label={formElementsArray[1].config.label}
              value={formElementsArray[1].config.value}
              invalid={!formElementsArray[1].config.valid}
              shouldValidate={formElementsArray[1].config.validation}
              touched={formElementsArray[1].config.touched}
              isReadOnly={this.state.isReadOnlyForm}
              changed={(event) =>
                this.inputChangedHandler(event, formElementsArray[1].id)
              }
            />
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-sm-6 text-right">
            <label
              htmlFor={formElementsArray[2].id}
              className="col-form-label required"
            >
              {exercice.form.hasSiren.label}
            </label>
          </div>
          <div className="col-sm-3 pt-2">
            <Input
              key={formElementsArray[2].id}
              elementType={formElementsArray[2].config.elementType}
              elementConfig={formElementsArray[2].config.elementConfig}
              label={formElementsArray[2].config.label}
              value={formElementsArray[2].config.value}
              invalid={!formElementsArray[2].config.valid}
              shouldValidate={formElementsArray[2].config.validation}
              touched={formElementsArray[2].config.touched}
              isReadOnly={this.state.isReadOnlyForm}
              changed={(event) =>
                this.inputChangedHandler(event, formElementsArray[2].id)
              }
            />
          </div>
        </div>

        {isHavingSiren === "true" ? (
          <div className="form-row mb-3">
            <div className="col-sm-6 text-right">
              <label
                htmlFor={formElementsArray[3].id}
                className="col-form-label required"
              >
                {exercice.form.siren.label}
              </label>
            </div>
            <div className="col-sm-3">
              <Input
                key={formElementsArray[3].id}
                elementType={formElementsArray[3].config.elementType}
                elementConfig={formElementsArray[3].config.elementConfig}
                label={formElementsArray[3].config.label}
                value={formElementsArray[3].config.value}
                invalid={!formElementsArray[3].config.valid}
                shouldValidate={formElementsArray[3].config.validation}
                touched={formElementsArray[3].config.touched}
                isReadOnly={this.state.isReadOnlyForm}
                changed={(event) =>
                  this.inputChangedHandler(event, formElementsArray[3].id)
                }
              />
            </div>
          </div>
        ) : (
          ""
        )}


        <div className="form-row">
          <div className="col-sm-6 mt-3 text-left">
            <a href="https://www.teledec.fr/la-declaration-resultat-et-la-liasse-fiscale-pour-les-LMNP-Loueurs-de-meubles-non-professionnels-2031"
              className="btn btn-default mr-3">
              Retour sur le site TELEDEC
            </a>
          </div>
          <div className="col-sm-3 mt-3 text-right">
            <Button classes="btn btn-success" btnType="Submit">
              {exercice.buttonSubmit}
              {this.props.isFetching === true ? <Loading /> : ""}
            </Button>
          </div>
        </div>

        <FormError errors={this.state.formErrors} />
      </form>
    );

    return (
      <Layout>
        {errorsMessages}
        <HeaderForm step="0" isReadOnlyForm={this.state.isReadOnlyForm} />
        <h1 className="text-center">{exercice.title}</h1>
        {form}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDossier: (dossier) => dispatch(DossierActions.saveDossier(dossier)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DossierExercicePage);
